<template>
  <div id="app">
    <b-navbar>
      <template slot="end">
        <b-navbar-item tag="router-link" to="/">
        Home
        </b-navbar-item>

        <b-navbar-item tag="router-link" to="SpoonKeitodama">
          毛糸玉(Spoon)
        </b-navbar-item>
        <b-navbar-item href="https://www.youtube.com/channel/UCGMg0X_5e5eOHIOSTjXG1JA/featured" target="_blank">
          丸ット団(Youtube)
        </b-navbar-item>
        <b-navbar-item href="https://www.mirrativ.com/user/8053721" target="_blank">
          毛糸(Mirrativ)
        </b-navbar-item>
      </template>
    </b-navbar>
    <section>
      <router-view></router-view>
    </section>
    <footer class="footer">
  <div class="content has-text-centered">
    <p>
      <strong>Keitodama Site.</strong> by <a href="https://e10ulen.hatenablog.com/">SEN@</a>
    </p>
  </div>
</footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue